module.exports = __webpack_public_path__ + "img/idcard_front.1db239ba.png";